export const DEFAULT_OPTIONS = {
  timeoutTime: 3000, // 默认为 3s 超时
  timeoutError: new Error('js bridge request timeout'),
};
